import React from 'react'
import NickyWrightsonImg from '../../images/speakers/Nicky-Wrightson.jpg'


const NickyWrightson = () => (
<section id="speaker" className="parallax-section">
	<div className="container">
    <br /><br /><br /><br /><br /><br />
		<div className="row">
        <div className="col-md-12 col-sm-12 wow fadeInUp" data-wow-delay="0.1s">
				<div className="team-wrapper">
					<h2>Nicky Wrightson</h2>
						<div className="row">
                            <div className="col-md-6">
                                <img src={NickyWrightsonImg} className="img-responsive" alt="Nicky Wrightson" />
                                <ul className="social-icon">
									<li><a href="https://www.linkedin.com/in/nickywrightson/" target="_blank" className="fa fa-linkedin wow fadeIn"></a></li>
									<li><a href="https://twitter.com/nickywrightson" target="_blank" className="fa fa-twitter wow fadeIn"></a></li>
								</ul>
                            </div>
                         <div className="col-md-5">
							<p>
                            Nicky has extensive experience delivering large scale cloud native architectures previously at the Financial Times and now at Skyscanner. She passionately promotes operability as a first class concern in developing these large distributed systems. She works now on the data platform at Skyscanner where the huge scale means a whole different set of problems to solve while still striving to be operable, cost effective and maintainable.
							</p>
                           </div>
                        </div>
                        <div className="row">
							<h4>Keynote: An Engineer's Guide to a Good Night's Sleep</h4>
							<p>
							As organisations look to empower engineers more, and embrace devops practices, we have seen the support role change quite a bit too. Developers are moving from being purely third line support, to working more collaboratively with engineers and operational staff. Also as we move to cloud native microservice solutions, the increased complexity and diversity of our production landscape means operational staff may well rely more heavily on the engineers, in particular out of hours.
                            <br /><br />
                            I have spent the last 18 years working across a plethora of industries utilising a myriad of technology and approaches. From working on everything from trading applications to content enrichment APIs, I have seen a lot of approaches and processes try to help minimise operational support for developers.
                            <br /><br />
                            In this talk, I will be exploring and discussing some of my top approaches and techniques to help reduce the risk of that dreaded 3am call! You will gain some practical insight into how to handle failure in today’s more complex distributed microservice systems. This will include looking at approaches to resiliency, understanding your system, understanding the requirements for fault tolerance, and the developers’ mindset necessary for this. I will be peppering this talk with real world examples, and an occasional war story along the way too.
							</p>
						</div>
				</div>
			</div>
        </div>
    </div>
</section>
)

export default NickyWrightson


// WEBPACK FOOTER //
// ./src/pages/speakers/nicky-wrightson.js